// TODO: убрать эту заглушку, скорее всего отрефакторить

interface TRecursiveRecord {
  [key: string]: TRecursiveRecord | string;
}
// eslint-disable-next-line import-x/no-mutable-exports
let routes: TRecursiveRecord;

export const setRoutes = (val: TRecursiveRecord): void => {
  routes = val;
};

export { routes };
